export var EAlkListMenuFill;
(function (EAlkListMenuFill) {
    EAlkListMenuFill["CLEAR"] = "clear";
    EAlkListMenuFill["UNDERLINE"] = "underline";
    EAlkListMenuFill["FILLED"] = "filled";
})(EAlkListMenuFill || (EAlkListMenuFill = {}));
